export const isAuthenticated = auth => auth && auth['access-token'] &&
  auth.expiry &&
  Math.floor(Date.now() / 1000) <= parseInt(auth.expiry, 10);

export default isAuthenticated;
